import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  settings: {
    enableToast: true,
    enableSound: false,
    position: 'top-right' // top-left, top-right, bottom-left, bottom-right
  }
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const notification = {
        id: Date.now().toString(),
        timestamp: new Date().toISOString(),
        read: false,
        ...action.payload
      };
      state.notifications.unshift(notification);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    markAsRead: (state, action) => {
      const notification = state.notifications.find(
        n => n.id === action.payload
      );
      if (notification) {
        notification.read = true;
      }
    },
    markAllAsRead: (state) => {
      state.notifications.forEach(notification => {
        notification.read = true;
      });
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    updateSettings: (state, action) => {
      state.settings = { ...state.settings, ...action.payload };
    }
  }
});

export const {
  addNotification,
  removeNotification,
  markAsRead,
  markAllAsRead,
  clearNotifications,
  updateSettings
} = notificationSlice.actions;

// Notification types and helper functions
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

export const createSuccessNotification = (message, title = 'Succès') => ({
  type: NOTIFICATION_TYPES.SUCCESS,
  title,
  message,
  duration: 5000
});

export const createErrorNotification = (message, title = 'Erreur') => ({
  type: NOTIFICATION_TYPES.ERROR,
  title,
  message,
  duration: 8000
});

export const createWarningNotification = (message, title = 'Attention') => ({
  type: NOTIFICATION_TYPES.WARNING,
  title,
  message,
  duration: 6000
});

export const createInfoNotification = (message, title = 'Information') => ({
  type: NOTIFICATION_TYPES.INFO,
  title,
  message,
  duration: 4000
});

export default notificationSlice.reducer;
